import { referencesActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_REFERENCE,
  FETCHING_REFERENCE,
  FETCH_REFERENCE_ERROR,
  FETCH_REFERENCES,
  FETCHING_REFERENCES,
  FETCH_REFERENCES_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_REFERENCE,
  DELETE_REFERENCE,
  ADD_REFERENCE,
  EDIT_REFERENCE,
  FORM_TOUCHED,
  NEW_FORM_REFERENCE,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  REFERENCE_FORM_ERROR,
  RESET_STATE
} = referencesActions

const initialState = {
  loadingReference: false,
  loadingReferences: false,
  fetchReferenceError: false,
  fetchReferencesError: false,
  references: [],
  order: {
    column: 'descricao',
    direction: 1
  },
  reference: {
    descricao: ''
  },
  referencesPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  referenceFormErrors: {},
  referenceFormTouched: false,
  modalOpen: false
}

const referenceSchema = {
  add: {
    descricao: {
      required: true,
      minValue: 3
    }
  },
  edit: {
    descricao: {
      required: true,
      minValue: 3
    }
  }
}

const ReferenceValidate = new ValidateFormObject(referenceSchema)

const references = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_REFERENCE:
      formSchemaType = action.reference._id ? 'edit' : 'add'
      return {
        ...state,
        reference: action.reference,
        referenceFormErrors: ReferenceValidate.validate({
          formObject: action.reference,
          formSchemaType
        })
      }
    case REFERENCE_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.reference._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        referenceFormErrors: ReferenceValidate.validate({
          formObject: state.reference,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_REFERENCE:
      return {
        ...state,
        reference: { ...initialState.reference },
        referenceFormErrors: ReferenceValidate.validate({}),
        referenceFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        referenceFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_REFERENCE:
      formSchemaType = (action.reference || {})._id ? 'edit' : 'add'
      return {
        ...state,
        reference: action.reference,
        loadingReference: false,
        fetchreferenceError: false,
        referenceFormTouched: false,
        referenceFormErrors: ReferenceValidate.validate({
          formObject: action.reference,
          formSchemaType
        })
      }
    case FETCHING_REFERENCE:
      return {
        ...state,
        loadingReference: true,
        fetchReferenceError: false
      }
    case DELETE_REFERENCE:
      return {
        ...state,
        loadingReferences: false,
        fetchReferenceError: false,
        references: state.references.map(reference => {
          if (reference._id === (action.reference || {})._id) {
            return action.reference
          }
          return reference
        })
      }
    case FETCH_REFERENCE_ERROR:
      return {
        ...state,
        loadingReference: false,
        reference: { ...initialState.reference },
        fetchReferenceError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        referencesPagination: {
          ...state.referencesPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        referencesPagination: {
          ...state.referencesPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_REFERENCES:
      return {
        ...state,
        loadingReferences: false,
        references: action.references,
        fetchReferencesError: false,
        order: action.order,
        referencesPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_REFERENCE:
      return {
        ...state,
        references: state.references.map(reference => {
          if (reference._id === action.reference._id) {
            return action.reference
          }
          return reference
        }),
        loadingReferences: false,
        fetchReferenceError: false,
        loadingReference: false,
        fetchReferencesError: false
      }
    case FETCHING_REFERENCES:
      return {
        ...state,
        loadingReferences: true,
        fetchReferencesError: false
      }
    case FETCH_REFERENCES_ERROR:
      return {
        ...state,
        loadingReferences: false,
        fetchReferenceError: action.error,
        loadingReference: false
      }
    case ADD_REFERENCE:
      return {
        ...state,
        loadingReferences: false,
        fetchReferenceError: false,
        loadingReference: false,
        references: [...state.references, action.reference]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default references



// WEBPACK FOOTER //
// ./src/reducers/references.js